// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResults-cls1_v-z","cls2":"AutoCompleteResults-cls2_J0I AutoCompleteResults-cls1_v-z"};